export default {
  getCarEquipment: (axios, digitalCertificateId) =>
    axios.get(`/api/digitalCertificates/${digitalCertificateId}/carEquipment`),
  saveCarEquipment: (axios, digitalCertificateId, data) =>
    axios.post(
      `/api/digitalCertificates/${digitalCertificateId}/carEquipment`,
      data,
    ),
}
